import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { ROUTES } from '@/constants';
import useAuth from '@/hooks/useAuth';
import { ROLE_DETAILS, USER_ROLES } from '@/roles';

const AuthRequired = () => {
  const { user, isAuthenticated, isSysAdmin, isAppCustomer } = useAuth();
  const { LOGIN, SELECT_FLEET, OVERVIEW } = ROUTES;
  const { pathname, search, hash } = useLocation();
  const shouldSelectFleet = isSysAdmin && user?.purpose === 'login';

  if (pathname.length > 1 && pathname.endsWith('/')) {
    return (
      <Navigate
        to={{
          pathname: pathname.slice(0, -1),
          search,
          hash,
        }}
        replace
      />
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={LOGIN} replace />;
  }

  if (shouldSelectFleet) {
    return pathname === SELECT_FLEET ? (
      <Outlet />
    ) : (
      <Navigate to={SELECT_FLEET} />
    );
  }

  const firstUserRole = user?.roles[0].toUpperCase() as keyof typeof USER_ROLES;
  const userRole = USER_ROLES[firstUserRole];
  const { accessibleRoutes } =
    ROLE_DETAILS.find((role) => role.key === userRole) ?? {};

  // app customer can't access validator tool
  const isValidatorToolRoute = pathname.includes(ROUTES.VALIDATOR_TOOL);
  const isPathAccessible =
    accessibleRoutes?.includes(pathname) &&
    !(isValidatorToolRoute && isAppCustomer);

  return isPathAccessible ? <Outlet /> : <Navigate to={OVERVIEW} />;
};

export default AuthRequired;
